export default "__VITE_ASSET__Bxkyr1ud__"